import { createSelector } from '@ngrx/store';

import { loyaltyMessagesState } from '../root';

export const getLoyaltyMessages = createSelector(
    loyaltyMessagesState,
    (loyaltyMessages) => loyaltyMessages
);
